import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

import { cn } from "../../lib/utils";

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        "z-[1200] overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md opacity-0 transition-opacity duration-150 ease-out will-change-[opacity] data-[state=closed]:opacity-0 data-[state=delayed-open]:data-[side=top]:opacity-100 data-[state=delayed-open]:data-[side=right]:opacity-100 data-[state=delayed-open]:data-[side=bottom]:opacity-100 data-[state=delayed-open]:data-[side=left]:opacity-100 data-[state=instant-open]:data-[side=top]:opacity-100 data-[state=instant-open]:data-[side=right]:opacity-100 data-[state=instant-open]:data-[side=bottom]:opacity-100 data-[state=instant-open]:data-[side=left]:opacity-100",
        className,
      )}
      {...props}
    />
  </TooltipPrimitive.Portal>
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
